// src/theme/ThemeContext.jsx
import React, { createContext, useState, useMemo, useContext, useEffect } from 'react';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import GlobalStyles from '@mui/material/GlobalStyles'; // 👈 1. استيراد GlobalStyles
import Cookies from 'js-cookie';
import { getAppTheme } from './theme'; 

// 1. إنشاء الـ Context
export const ThemeModeContext = createContext({
  toggleColorMode: () => {},
  mode: 'light',
});

// 2. إنشاء المزود (Provider)
export const ThemeContextProvider = ({ children }) => {
  
  // قراءة القيمة المحفوظة في الكوكيز كقيمة ابتدائية، أو استخدام 'light' كافتراضي
  const [mode, setMode] = useState(() => {
    const savedMode = Cookies.get('themeMode');
    return savedMode ? savedMode : 'light';
  });

  // تحديث الكوكيز في كل مرة يتغير فيها الوضع (mode)
  useEffect(() => {
    Cookies.set('themeMode', mode, { expires: 365 }); 
  }, [mode]);

  // دالة التبديل بين الوضعين
  const colorMode = useMemo(
    () => ({
      toggleColorMode: () => {
        setMode((prevMode) => (prevMode === 'light' ? 'dark' : 'light'));
      },
      mode,
    }),
    [mode]
  );

  // توليد الثيم بناءً على الوضع الحالي
  const theme = useMemo(() => getAppTheme(mode), [mode]);

  return (
    <ThemeModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        
        {/* 👈 2. إضافة الأنميشن التدريجي هنا */}
        <GlobalStyles
          styles={{
            // نطبق التأثير على جميع العناصر
            '*': {
              // نحدد الخصائص التي نريد أن تتأثر بالأنميشن فقط حتى لا نفسد حركات أخرى
              transitionProperty: 'background-color, color, border-color, fill, stroke',
              transitionDuration: '0.4s', // مدة الأنميشن (يمكنك تغييرها)
              transitionTimingFunction: 'ease-in-out', // شكل الحركة
            },
          }}
        />

        {children}
      </ThemeProvider>
    </ThemeModeContext.Provider>
  );
};

// 3. Hook مخصص لتسهيل استخدام الثيم في أي مكون
export const useThemeMode = () => useContext(ThemeModeContext);